import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core'
import { getSettingsState } from '@containers/settings/settings.selectors'
import { Store, select } from '@ngrx/store'
import { FetchFormsRequest } from '@shared/shared.actions'
import { getFormsState } from '@shared/shared.select'
import { Subscription } from 'rxjs'

@Component({
  selector: 'property-type-modal',
  templateUrl: './property-type-modal.component.html',
  styleUrls: ['./property-type-modal.component.css'],
})
export class PropertyTypeModalComponent implements OnInit, OnDestroy {
  @Output() public onSave: EventEmitter<any> = new EventEmitter()
  @Output() public onClose: EventEmitter<any> = new EventEmitter()
  @Input() public isOpen: boolean

  public activeFormId: number
  public selectedFormId: number
  public selectedPropertyType: string
  public forms: any[]
  public forms$: Subscription
  public settings$: Subscription
  public settings: any = {}

  constructor(public store: Store<any>) {}

  ngOnInit() {
    this.forms$ = this.store.pipe(select(getFormsState)).subscribe((forms) => {
      this.forms = forms.get('data').toJS()
    })

    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        if (state.getIn(['data', 'system'])) {
          this.activeFormId = state.getIn([
            'data',
            'system',
            'SYSTEM_ACTIVE_DATA_CYCLE',
            'evaluationFormId',
          ])

          this.selectedFormId = this.activeFormId
        }
      })

    this.store.dispatch(new FetchFormsRequest())
  }

  get propertyTypes() {
    return (
      this.forms.find(({ id }) => this.selectedFormId === id)?.propertyTypes ||
      []
    )
  }

  ngOnDestroy() {
    this.forms$.unsubscribe()
  }
}
